(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const select = form.querySelector('[name="id"]');
      const button = form.querySelector('[type="submit"]');
      const price = form.querySelector('[data-variant-price]');
      const variants = JSON.parse(form.querySelector('[data-variants]')?.textContent || '[]');
      const updateVariant = () => {
        const variant = variants.find(item => String(item.id) === select?.value);
        if (!variant) return;
        if (price) price.textContent = variant.price;
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Ajouter au panier' : 'Indisponible';
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
        const image = document.querySelector('[data-main-product-image]');
        if (image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
          image.alt = variant.image_alt;
        }
      };
      select?.addEventListener('change', updateVariant);
      const name = form.querySelector('[data-pet-name]');
      const preview = form.querySelector('[data-name-preview]');
      const count = form.querySelector('[data-name-count]');
      name?.addEventListener('input', () => {
        if (preview) preview.textContent = name.value.trim() || 'Son prénom';
        if (count) count.textContent = `${name.value.length} / ${name.maxLength}`;
      });
      form.addEventListener('submit', event => {
        if (name && !name.value.trim()) {
          event.preventDefault();
          name.setCustomValidity('Saisissez le prénom de votre compagnon.');
          name.reportValidity();
          name.focus();
          return;
        }
        button.textContent = 'Ajout en cours…';
        button.disabled = true;
      });
      name?.addEventListener('input', () => name.setCustomValidity(''));
    });
  };
  bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-product-form]').forEach(form => {
    const select = form.querySelector('[name="id"]');
    const variants = JSON.parse(form.querySelector('[data-variants]')?.textContent || '[]');
    const variant = variants.find(item => String(item.id) === select?.value);
    const button = form.querySelector('[type="submit"]');
    if (button && variant) { button.disabled = !variant.available; button.textContent = variant.available ? 'Ajouter au panier' : 'Indisponible'; }
  }));
})();
